// @flow
/* eslint-disable import/no-named-as-default-member */
import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { Loader } from "semantic-ui-react";

import useGoogleAnalytics from "../utils/helpers/useGoogleAnalytics";
import Template from "../components/Template";

const HomePage = React.lazy(() => import("../modules/home/pages"));
const SearchPage = React.lazy(() => import("../modules/search/pages"));
const SettingsPage = React.lazy(() => import("../modules/settings/pages"));
// const StatisticPage = React.lazy(() => import("../modules/stats/pages"));
const NotFoundPage = React.lazy(() => import("../components/NotFound"));

const Routes = () => {
  useGoogleAnalytics();

  return (
    <Template>
      <React.Suspense fallback={<Loader active inline="centered" />}>
        <Switch>
          <Route component={HomePage} exact path="/" />
          <Route component={SearchPage} path="/report/:id" />
          <Route component={SettingsPage} path="/settings/themes" />
          {/* <Route component={StatisticPage} path="/stats" /> */}
          <Route component={NotFoundPage} path="*" />
        </Switch>
      </React.Suspense>
    </Template>
  );
};

export default Routes;
